import { BottomSheet } from '../bottom-sheet/bottom-sheet.js';
import styles from './sheet.module.css';

export type SheetAction = {
  id: string;
  label: string;
  danger?: boolean;
  disabled?: boolean;
  onSelect: () => void;
};

type SheetProps = {
  open: boolean;
  actions: SheetAction[];
  onClose: () => void;
  title?: string;
  closeLabel?: string;
};

export const Sheet = ({ open, actions, onClose, title, closeLabel }: SheetProps) => (
  <BottomSheet open={open} onClose={onClose} title={title} label="Дії" closeLabel={closeLabel}>
    <ul className={styles.actions}>
      {actions.map((action) => (
        <li key={action.id} className={styles.action}>
          <button
            type="button"
            className={`${styles.actionButton} ${action.danger === true ? styles.danger : ''}`}
            disabled={action.disabled}
            onClick={action.onSelect}
          >
            {action.label}
          </button>
        </li>
      ))}
    </ul>
  </BottomSheet>
);
